import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { session } from '../../../services/session';

import Icon from '../../ui/icon';

const CreatedLinks = ({ setSelectedStory, oldLinks, setOldLinks, newLinks }) => {
  const [copied, setCopied] = useState(false);
  const [copying, setCopying] = useState(false);
  const [copiableText, setCopiableText] = useState(newLinks);
  const ref = useRef(null);

  useEffect(() => {
    if (copying)
      setTimeout(() => {
        setCopying(false);
      }, 1000);
  }, [copying]);

  async function copyLinks() {
    try {
      await navigator.clipboard.writeText(ref.current.value);
      setCopied(true);
      setCopying(true);
    } catch (err) {
      alert(`Failed to copy links: ${err}`);
    }
  }

  function formatLinks(links) {
    return links
      .split('\n')
      .filter(link => link !== '')
      .join('\n\n');
  }

  const copyIcon = !copying ? <Icon iconName="copy" size={16} /> : null;

  return (
    <div className="created-links">
      <div className="header">All done!</div>
      <div className="description">
        Below are your new Narrativ links. Just copy and paste them into your post and you’re ready
        to earn whenever you drive a sale.
      </div>
      <div className="content">
        <div className="old-links">
          <div className="list-title">Old Links</div>
          <div className="list">
            <textarea value={formatLinks(oldLinks)} disabled={true} />
          </div>
        </div>
        <div className="arrow-container">
          <Icon iconName="arrowRight" size={31} />
        </div>
        <div className="new-links">
          <div className="list-title">Narrativ Links</div>
          <div className={`list ${copied ? 'copied' : ''}`}>
            <textarea
              value={copiableText}
              onChange={e => setCopiableText(e.target.value)}
              ref={ref}
            />
            <button className="copy-links" onClick={copyLinks}>
              {copyIcon}
              {copying ? 'Copied!' : 'Copy New Links'}
            </button>
          </div>
        </div>
      </div>

      <button
        className="confirm-button"
        onClick={() => {
          setSelectedStory(null);
          setOldLinks('');
        }}
      >
        <Link to={`/v2/publisher/${session.orgId}/links/create-links/select-story`}>
          Create More Links
        </Link>
      </button>
      <button className="confirm-button">
        <Link to={`/v2/publisher/${session.orgId}/links/my-links`}>Go To My Links</Link>
      </button>
    </div>
  );
};

export default CreatedLinks;
